export default __webpack_public_path__ + "static/media/olumide.5d227239.png";